export default "__VITE_ASSET__CcsQVFMN__"